type FacetedFilterValue = {
  value: string;
  count: number;
};

type FacetedFiltersResponse = {
  error?: boolean;
  msg?: string;
  data?: Record<string, FacetedFilterValue[]>;
};

type FacetedFiltersRequest = {
  groupId: string | number;
  need: string[];
  selected?: Record<string, string[]>;
};

const buildBaseUrl = (rawUrl?: string) =>
  String(rawUrl ?? "")
    .trim()
    .replace(/\/+$/, "");

export const useFacetedFiltersApi = () => {
  const runtimeConfig = useRuntimeConfig();
  const baseUrl = buildBaseUrl(runtimeConfig.public.facetedFilterApiUrl);

  const getFilters = async ({
    groupId,
    need,
    selected = {},
  }: FacetedFiltersRequest) => {
    if (!baseUrl) {
      throw new Error("NUXT_PUBLIC_FACETED_FILTER_API_URL is not configured");
    }

    const query = new URLSearchParams();
    query.set("group_id", String(groupId));
    query.set("need", need.join("+"));

    Object.entries(selected).forEach(([name, values]) => {
      const cleanValues = values.filter(Boolean);
      if (cleanValues.length) {
        query.set(name, cleanValues.join("+"));
      }
    });

    const response = await $fetch<FacetedFiltersResponse>(
      `${baseUrl}/filters?${query.toString()}`,
      {
        method: "GET",
      },
    );

    if (response.error) {
      throw new Error(response.msg || "Ошибка получения фасетных фильтров");
    }

    return response.data ?? {};
  };

  return {
    isConfigured: Boolean(baseUrl),
    getFilters,
  };
};
